import React from 'react';
import { Edit, Trash2, Archive, Users, CheckCircle } from 'lucide-react';

const SalleCard = ({ 
  salle, 
  isArchived = false,
  onEdit, 
  onArchive, 
  onRestore, 
  onDelete 
}) => {
  const cardClasses = isArchived 
    ? "bg-gray-50 rounded-xl shadow-md overflow-hidden opacity-75 hover:opacity-100 transition-opacity"
    : "bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow";

  const titleClasses = isArchived 
    ? "text-xl font-bold text-gray-600"
    : "text-xl font-bold text-[#202654]";

  const usersIconClasses = isArchived 
    ? "h-5 w-5 text-gray-500 mr-2"
    : "h-5 w-5 text-blue-500 mr-2";

  return (
    <div className={cardClasses}>
      <div className="p-6">
        <div className="flex justify-between items-start">
          <h3 className={titleClasses}>{salle.libelle}</h3>
          <div className="flex space-x-1">
            {!isArchived ? (
              <>
                <button
                  onClick={() => onEdit(salle)}
                  className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
                  title="Modifier"
                >
                  <Edit className="h-5 w-5" />
                </button>
                <button
                  onClick={() => onArchive(salle)}
                  className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
                  title="Archiver"
                >
                  <Archive className="h-5 w-5" />
                </button>
              </>
            ) : (
              <button
                onClick={() => onRestore(salle)}
                className="p-2 rounded-lg text-green-600 hover:bg-green-50 transition-colors"
                title="Restaurer"
              >
                <CheckCircle className="h-5 w-5" />
              </button>
            )}
            <button
              onClick={() => onDelete(salle)}
              className="p-2 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
              title="Supprimer"
            >
              <Trash2 className="h-5 w-5" />
            </button>
          </div>
        </div>
        <div className="mt-4 flex items-center text-gray-700">
          <Users className={usersIconClasses} />
          <span>Capacité: <strong>{salle.capacite}</strong> places</span>
        </div>
        <div className="mt-2 text-sm text-gray-500">
          {isArchived ? 'Archivée le ' : 'Mise à jour le '}
          {new Date(salle.updated_at).toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default SalleCard; 